import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'react-bootstrap';
import { InternalIBT } from './InternalIBT';
import { NormalIBT } from './NormalIBT'; 
import { IntransitIBT } from './IntransitIBT';
import { useAuth } from '../../contexts/AuthContext';
import { IQuerySelectData } from '../solution/Interfaces';

interface IStore {
    id: string;
    code: string;
    name: string;
    email: string
    customer_code: string;
    costing_code: string;
    sit_location: string;
    shopify_location_id: string;
    created: string;
    updated: string| null;

    // Optional new fields
    address?: string;
    stock_receipt_count?: number;
    stock_receipt_min_created?: string | null;
    stock_take_count?: number;
    stock_take_min_created?: string | null;
    cycle_count_count?: number;
    cycle_count_min_created?: string | null;
    stock_return_count?: number;
    stock_return_min_created?: string | null;
    stock_transfer_count?: number;
    stock_transfer_min_created?: string | null;
    internal_stock_transfer_count?: number;
    internal_stock_transfer_min_created?: string | null;
    send_stock_transfer_count?: number;
    send_stock_transfer_min_created?: string | null;
    stock_receive_count?: number;
    stock_receive_min_created?: string | null;
}

interface IComponent {
    store: IStore;
    close: () => void;
    isCycleCount?: boolean;
    allStores?: IStore[];
}


export const IBTManagement: React.FC<IComponent | null> = (props) => {

     // early return
    
    const { fetchData, userDetail}  = useAuth();
    const queryUrlSelect: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data?includeCount=true"}`;
    const [storeState, setStoreState] = useState<IStore[]>([]);
    const [view, setView] = useState<'internal_ibt' | 'send_stock_ibt' | 'receive_stock_ibt' | null>(null); 

    const defaultQueryState: IQuerySelectData = {
              appCode: "ares",
              selectCode: "store-summary",  
              where: "",  
              orderBy: "",
            };    
        
    const [queryState, setQueryState] = useState<IQuerySelectData>(defaultQueryState);

    useEffect(() => {
      if (props?.store?.id) {
        setQueryState(prev => ({
          ...prev,
          where: `id = '${props.store.id}'`,
        }));
      }
    }, [props?.store?.id]);

    useEffect(() => {
      if (queryState.where) {
        fetchInterBranchTransfers();
      }
    }, [queryState.where]);

  
    
    
    const processInterBranchTransfers = (result: any) => {
        console.log(`This is the result`, result);
        const store: IStore[] = [];
        for(const key in result.data){
            store.push({...result.data[key].data, ...result.data[key].control, ...result.data[key].undefined});
        }
        setStoreState(store);
    }
    
    const fetchInterBranchTransfers = () => {
        fetchData(queryUrlSelect, {method:"POST", body: JSON.stringify(queryState)}, processInterBranchTransfers);
    }
    

  
   
    const renderComponent = () => {
      const onBack = () => setView(null);
      if (!props) return null;
      switch (view) {
        case 'internal_ibt': return <InternalIBT store={props.store} onBack={onBack} />;
        case 'send_stock_ibt': return <NormalIBT store={props.store} onBack={onBack} allStores={props.allStores ?? []} />;
        case 'receive_stock_ibt': return <IntransitIBT store={props.store} onBack={onBack} />;
        default: return null;
      }
    };


  const getButtonVariantByDate = (dateStr?: string | null, warningHours = 24, dangerHours = 48): string => {
          if (!dateStr) return 'btn-secondary';
  
          const createdDate = new Date(dateStr);
          const now = new Date();
          const diffHours = (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60);
  
          if (diffHours < dangerHours) return 'btn-success';
          if (diffHours > dangerHours) return 'btn-danger';
          if (diffHours > warningHours) return 'btn-warning';
          return 'btn-secondary';
      };
  
  
      const getElapsedTime = (dateStr?: string | null, warningHours = 24, dangerHours = 48): string => {
         if (!dateStr) return 'No Open Activity';

        const createdDate = new Date(dateStr);
        const now = new Date();
        const diffMs = now.getTime() - createdDate.getTime();
        const diffHours = diffMs / (1000 * 60 * 60);
        const diffDays = diffHours / 24;

        if (diffDays > 365) {
            return 'Current Activity';
        }

        if (diffHours > dangerHours) {
            const daysElapsed = Math.floor(diffDays);
            return `Current Activity`;
        }

        if (diffHours > warningHours) {
            return 'Current Activity';
        }

        return 'Current Activity';
     };
  
    const getCountButton = ( label: string, count: number | undefined, date: string | null | undefined, onClick: () => void ) => (
        <button className={`btn ${getButtonVariantByDate(date)} d-flex align-items-center justify-content-between px-2 py-1`} 
                style={{ fontSize: '0.75rem', minWidth: '190px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)', transition: 'box-shadow 0.2s ease-in-out' }} onClick={onClick} title={label}>
            <span className="text-truncate" style={{ maxWidth: '160px' }}>
                {getElapsedTime(date)}
            </span>
            <span className="bg-light text-black rounded d-inline-flex align-items-center justify-content-center" style={{ minWidth: '20px', height: '20px', padding: '0 4px', fontSize: '0.75rem', lineHeight: 1 }}>
            {count}
            </span>
        </button>
    );
    
    const thStyle = {
      backgroundColor: '#f7f5f5',
      border: '1px solid #deebed',
      fontWeight: 600,
      padding: '10px 8px',
      fontSize: '0.85rem',
    };

    const cellStyle: React.CSSProperties = {
        border: '1px solid #deebed',
        whiteSpace: 'nowrap',
        padding: '5px 8px',
        fontSize: '0.85rem',
        verticalAlign: 'middle',
        fontWeight: 500,
    };

    const cellLabelStyle: React.CSSProperties = {
        backgroundColor: '#f7f5f5',
        border: '1px solid #deebed',
        whiteSpace: 'nowrap',
        padding: '10px 8px',
        fontSize: '0.85rem',
        verticalAlign: 'middle',
        fontWeight: 600,
    };

    const TableComponent = (storeState: IStore[]) => {
        // const colGroup = (
        //     <colgroup>
        //     <col style={{ width: '180px' }} />
        //     <col style={{ width: '190px' }} />
        //     <col style={{ width: '190px' }} />
        //     <col style={{ width: '190px' }} />
        //     <col style={{ width: '190px' }} />
        //     <col style={{ width: '190px' }} />
        //     </colgroup>
        // );

        const totals = storeState.reduce(
            (acc, store) => {
            acc.internal_stock_transfers += store.internal_stock_transfer_count || 0;
            acc.send_stock_transfers += store.send_stock_transfer_count || 0;
            acc.receive_stock_transfers += store.stock_receive_count || 0;
            return acc;
            },
            { internal_stock_transfers: 0, send_stock_transfers: 0, receive_stock_transfers: 0 }
        );

        return (
            <div style={{ width: '100%' }}>
            {/* First Table - Total Counts */}
             <h5 className="mt-3 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1">
                Store Overview
            </h5>
            <table
                className="notification-summary-table fixed-table"
                style={{ width: '100%', tableLayout: 'fixed' }}
            >
                {/* {colGroup} */}
                <thead>
                <tr>
                    <th style={thStyle}></th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Internal IBT</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Send Stock</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Recieve Stock</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style={{ ...cellLabelStyle, textAlign: 'center' }}>
                      Total Open / Sent Transactions
                    </td>
                    <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600'}}>{totals.internal_stock_transfers}</td>
                    <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600'}}>{totals.send_stock_transfers}</td>
                    <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600'}}>{totals.receive_stock_transfers}</td>
                </tr>
                </tbody>
            </table>

            {/* Second Table - Per Store Details */}
             <h5 className="mt-5 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1">
                Store Management
            </h5>
            <table
                className="notification-summary-table fixed-table mt-4"
                style={{ width: '100%', tableLayout: 'fixed' }}
            >
                {/* {colGroup} */}
                <thead>
                <tr>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Store Name</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Internal IBT</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Send Stock</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Recieve Stock</th>
                </tr>
                </thead>
                <tbody>
                {storeState.map((store: IStore) => (
                      <tr key={store.id}>
                      <td style={{ ...cellStyle, paddingRight: '4px' }}>
                            <span>
                            {store.name}
                            </span>
                        </td>
                        <td style={cellStyle}>
                            <div className="d-flex justify-content-center">
                            {getCountButton(
                                'View Internal Stock Transfers Details',
                                store?.internal_stock_transfer_count,
                                store?.internal_stock_transfer_min_created,
                                () => setView('internal_ibt')
                            )}
                            </div>
                        </td>
                        <td style={cellStyle}>
                            <div className="d-flex justify-content-center">
                            {getCountButton(
                                'View Send Stock Transfers Details',
                                store?.send_stock_transfer_count,
                                store?.send_stock_transfer_min_created,
                               () => setView('send_stock_ibt')
                            )}
                            </div>
                        </td>
                        <td style={cellStyle}>
                            <div className="d-flex justify-content-center">
                              {getCountButton(
                                'View Recieve Stock Transfers Details',
                                store?.stock_receive_count,
                                store?.stock_receive_min_created,
                                () => setView('receive_stock_ibt')
                              )}
                            </div>
                        </td>               
                      </tr>
                    ))}
                </tbody>
            </table>
          </div>
          );
        };
    
       
  
    return (
      <>
        {!view ? (
          <Card>
            <Card.Header>
              <Card.Title>{`Stock Transfers (IBT) - [${props?.store.name}]`}</Card.Title>                       
            </Card.Header>
            <CardBody>     
              <div className="d-flex gap-1">
                <button
                  className="btn btn-secondary h-100"
                  style={{width: "120px"}}
                  onClick={() => props?.close()}
                >
                  {"Back to Store"}
                </button>
              </div>
              <br />
              <div className="notification-summary-outer-container" style={{ maxHeight: 'none' }}>
                    <div className="outer-inner-container">
                        {TableComponent(storeState)}
                    </div>
              </div>
              {/* <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="text-secondary text-decoration-none">
                    {props.store.name}
                  </div>
                  <div className="d-flex gap-2">  
                    <button className="btn btn-secondary btn-sm" style={{ width: "150px" }} onClick={() => setView('internal_ibt')}>
                       Internal (IBT)
                    </button>
                    <button className="btn btn-secondary btn-sm" style={{ width: "150px" }} onClick={() => setView('send_stock_ibt')}>
                       Send Stock (IBT) 
                    </button>
                    <button className="btn btn-secondary btn-sm" style={{ width: "150px" }} onClick={() => setView('receive_stock_ibt')}>
                       Receive Stock (IBT) 
                    </button>                 
                  </div>
                </li>   
              </ul> */}
            </CardBody>
          </Card>    
        ) : (
          <>{renderComponent()}</>
        )}
      </>
    );
  };
